import axios from "axios";

const openEmrApi = axios.create({
  baseURL: process.env.REACT_APP_OPENEMR_BASE || "https://emr.brainymed.com/frisco/customapi",
});

// ✅ RESPONSE INTERCEPTOR
openEmrApi.interceptors.response.use(
  (response) => {
    // Instead of returning full Axios response object,
    // this returns ONLY the data portion.
    return response.data;
  },
  (error) => {
    // Handle errors globally if needed
    return Promise.reject(error);
  }
);

export default openEmrApi;
